export const RightArrow = () => (
	<svg
		width="22"
		height="38"
		viewBox="0 0 22 38"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M20.7677 17.2322C21.744 18.2084 21.7441 19.7914 20.7678 20.7677L4.85853 36.6782C3.88225 37.6545 2.29934 37.6546 1.32299 36.6783C0.346645 35.7021 0.346587 34.1191 1.32286 33.1428L15.4645 19.0001L1.3218 4.85853C0.345452 3.88225 0.345394 2.29934 1.32167 1.32299C2.29794 0.346646 3.88085 0.346586 4.8572 1.32286L20.7677 17.2322ZM16.9999 16.5001L18.9999 16.5L19.0001 21.5L17.0001 21.5001L16.9999 16.5001Z"
			fill="#002849"
		/>
	</svg>
);

export const LeftArrow = () => (
	<svg
		width="22"
		height="38"
		viewBox="0 0 22 38"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.2323 17.2322C0.255952 18.2084 0.255893 19.7914 1.23217 20.7677L17.1415 36.6782C18.1177 37.6545 19.7007 37.6546 20.677 36.6783C21.6534 35.7021 21.6534 34.1191 20.6771 33.1428L6.53553 19.0001L20.6782 4.85853C21.6545 3.88225 21.6546 2.29934 20.6783 1.32299C19.7021 0.346646 18.1191 0.346586 17.1428 1.32286L1.2323 17.2322ZM5.00009 16.5001L3.00009 16.5L2.99991 21.5L4.99991 21.5001L5.00009 16.5001Z"
			fill="#002849"
		/>
	</svg>
);
